
  
  export default {
    name: 'IndexPage',
    async asyncData({ error }) {
      error({ statusCode: 404, message: 'Page not found' });
    }
  }
  